import type { HealthCheckFunction } from '../../types.tsx';

const globalObj = window || global;
const defaultHealthcheck = (callback: (obj?: { isSuccess: boolean }) => void) =>
	callback({ isSuccess: true });

export const provideHealthcheck = (healthcheck: HealthCheckFunction = defaultHealthcheck): void => {
	globalObj.performHealthcheck = healthcheck;
};
